import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  padding: 1rem;

  font-family: "Mulish";

  background-color: #f5f5f5;

  .hidden {
    display: none;
  }

  .show {
    display: flex;
  }

  #header {
    font-size: 1.3rem;
    font-weight: bold;

    span {
      color: #3751ff;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  padding: 1rem 1rem 0 1rem;

  #back-button {
    display: flex;

    position: absolute;

    justify-content: center;

    top: 10%;

    width: 5%;
    height: 3rem;

    a {
      text-decoration: none;
    }

    #svg-icon {
      width: 2rem;
      height: 3rem;

      stroke: black;
    }
  }

  .top-wrapper {
    display: flex;

    width: 100%;
    height: 30%;

    gap: 3.5rem;

    padding: 1rem 5rem 0 5rem;
  }

  .infos-wrapper {
    display: flex;
    flex-direction: column;

    width: 65%;
    height: 100%;

    border: 1px solid #dfe0eb;
    border-radius: 0.5rem;

    padding: 1rem 3rem;

    background-color: white;

    .top-info {
      display: flex;

      width: 100%;
      height: 30%;

      justify-content: space-between;
      align-items: center;

      p {
        font-size: 1.5rem;
        font-weight: bold;
      }

      button {
        width: 10rem;
        height: 3rem;

        border: none;
        border-radius: 2rem;

        background-color: #3751ff;

        color: white;

        cursor: pointer;
      }
    }

    .bottom-info {
      display: flex;
      height: 70%;

      justify-content: space-between;
      align-items: center;

      .info {
        display: flex;
        flex-direction: column;

        height: 100%;

        justify-content: space-evenly;

        gap: 0.5rem;
      }

      .info > div {
        display: flex;

        align-items: center;

        gap: 0.5rem;
        p {
          color: #8a8a8a;

          font-size: 1.1rem;
        }
      }
    }
  }

  .register-management {
    display: flex;
    flex-direction: column;

    width: 25%;
    height: 100%;

    border-radius: 0.5rem;
    border: 1px solid #dfe0eb;

    background-color: white;

    align-items: center;
    justify-content: space-between;

    padding: 1rem;

    p {
      color: black;

      font-size: 1.2rem;
      font-weight: bold;
    }

    .reg-button {
      display: flex;

      align-items: center;
      justify-content: center;

      width: 75%;
      height: 4rem;

      font-size: 1rem;

      border: none;
      border-radius: 2rem;

      color: white;

      cursor: pointer;
    }

    #rec-pass {
      background-color: #3751ff;
    }

    #delete-user {
      background-color: #f12b2c;
    }
  }

  .bottom-wrapper {
    display: flex;

    width: 100%;
    height: 80%;

    padding: 1rem 5rem;

    gap: 1.5rem;
  }

  .process-management {
    display: flex;
    flex-direction: column;

    width: 65%;
    height: 100%;

    background-color: white;

    border-radius: 0.5rem;
    border: 1px solid #dfe0eb;

    table {
      display: flex;
      flex-direction: column;

      width: 100%;
      height: 100%;

      align-items: center;
    }
  }

  .tr-wrapper {
    display: flex;

    width: 100%;
    height: 4rem;

    min-height: 4rem;

    font-size: 1rem;

    justify-content: center;
    align-items: center;

    margin-bottom: 1rem;

    :hover {
      background-color: #f4f5fe;

      cursor: pointer;
    }
  }

  #tr-title {
    margin-bottom: 2rem;

    background-color: white;

    cursor: default;
  }

  th,
  td {
    display: flex;

    width: 100%;
    height: 2.5rem;

    justify-content: center;
    align-items: center;
  }

  td {
    color: #8a8a8a;

    font-size: 1.2rem;
  }

  #status {
    border-radius: 2rem;

    background-size: 50%;
    background: #f12b2c;

    color: white;
  }

  #name {
    text-transform: capitalize;
  }

  .analytics {
    display: flex;
    flex-direction: column;

    width: 30%;
    height: 100%;

    align-items: center;
    justify-content: space-between;

    border: 1px solid #dfe0eb;
    border-radius: 0.5rem;

    background-color: white;

    padding: 1rem;

    p {
      font-size: 1.2rem;
      font-weight: bold;
    }
  }

  .chart-wrapper {
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 40%;

    align-items: center;

    gap: 1rem;

    div {
      display: flex;
      flex-direction: column;

      width: 100%;
      height: 100%;

      align-items: center;
      justify-content: center;

      border: 2px dotted black;
      p {
        color: #8a8a8a;
      }
    }
  }
`;
